import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { useRealtimeUnits } from 'Core/hooks';
import {openModalBehaviorAdvanceFilter,} from "./redux/slice";
import {useIntl} from "react-intl";

//Styles
import './styles.scss'
import SidePanel, {SidePanelBody, SidePanelHeader} from 'Components/SidePanel';
import {Button} from 'Components/uiControls'
import {Grid} from "@mui/material";
import Select from "Components/Select";
import colors from "Assets/sass/core/vars.scss";
import {
    COLOR_EVT_OTHER,
    COLOR_BLACK,
    METRIC_SPEED,
    METRIC_SPEED_LABEL,
    METRIC_VALUE_SPEED_LIST,
    useMetricTypesOptions, CATEGORY_DRIVER, CATEGORY_ADVANCED
} from "Modules/settings/views/behavior/redux/helpers";
import _ from "lodash";
import {convertToKPH} from "Core/data/Helpers";

const AdvanceFilterMetric = (props) => {
    const {preferencesRef} = props;
    const dispatch = useDispatch();
    const {messages, locale} = useIntl();
    let {open, hasFilters, filter, preference} = useSelector((state) => state.manageBehaviorAdvanceFilterRedux);
    const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    const user = useSelector((state) => state.securityRedux.user);
    const {metricTypesOptions, getNameMetricType} = useMetricTypesOptions(user.isKph, messages);
    const [metricsTypesOptions, setMetricsTypesOptions] = useState(metricTypesOptions);

    const {categoriesTypesOptions, allMetricOptions} = useMemo(() => {
            const speedFilters = METRIC_VALUE_SPEED_LIST.map((metric) => {
                return {
                    id: `${METRIC_SPEED_LABEL}-${metric.value}`,
                    name: getNameMetricType({metric: METRIC_SPEED_LABEL, metricValue: user.isKph ? convertToKPH(metric.value) : metric.value})
                }
            })
            let metricsOptions = metricTypesOptions.filter(option => option.id !== METRIC_SPEED);
            metricsOptions.push({
                id: METRIC_SPEED,
                label: getNameMetricType({metric: METRIC_SPEED}),
                options: speedFilters,
            })

            const validateVidFleet = units.filter(data => data.manufacturerName?.toUpperCase() === 'VIDFLEET' || data.linkedUnit?.manufacturerName?.toUpperCase() === 'VIDFLEET');

            let categoryOptions = metricTypesOptions.map(category => {
                return {
                    id: category.id,
                    label: category.label,
                }
            });

            if (!validateVidFleet?.length){
                categoryOptions = categoryOptions.filter(category => ![CATEGORY_DRIVER,CATEGORY_ADVANCED].includes(category.id));
                metricsOptions = metricsOptions.filter(category => ![CATEGORY_DRIVER,CATEGORY_ADVANCED].includes(category.id));
            }
            return {
                categoriesTypesOptions: categoryOptions,
                allMetricOptions: metricsOptions
            }
        }, [locale]
    );

    const changePreferences = useCallback((newValues) => {
        const oldPreferences = preferencesRef?.current?.getPreferences("User", "behaviorView") || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = {...oldPreferences, ...newValues}
            preferencesRef.current.savePreference("User", "behaviorView", currentPreferences)
        }

    }, [])

    const clearFilters = useCallback(() => {
        setMetricsTypesOptions(allMetricOptions)
        dispatch(openModalBehaviorAdvanceFilter({hasFilters: false, filter: {}, preference: null}));
        changePreferences({categories: [], metrics: []})
    }, [])

    useEffect(() => {
        if (preference){
            dispatch(openModalBehaviorAdvanceFilter({filter: preference}));
        }
        if (allMetricOptions.length) {
            setMetricsTypesOptions(allMetricOptions);
        }
    }, [allMetricOptions]);

    const formatGroupLabel = (data) => (
        <>
            <div style={{
                borderTop: `1px solid ${colors[COLOR_EVT_OTHER]}`,
                width: '100%'
            }}>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px',
                paddingTop: '10px'
            }}>
                <span style={{
                    fontWeight: 'bold',
                    color: colors[COLOR_BLACK],
                    fontSize: '12px'
                }}>{data?.label}
                </span>
            </div>
        </>
    );

    return (
        <SidePanel
            style={{
                zIndex: 2,
                width: 400,
                transform: 'translateX(400px)',
                height: "calc(100% - 50px)"
            }}
            contentStyle={{
                height: "calc(100% - 50px)"
            }}
            classSidePanel={hasFilters ? 'side-panel-icon-filter' : 'side-panel-icon'}
            isOpen={open}
            toggle={() => dispatch(openModalBehaviorAdvanceFilter({open: !open}))}
        >
            <SidePanelHeader>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Grid item>
                        <h2 style={{margin: 0}}>
                            {messages['fleetView_advancedFilters']}
                        </h2>
                        <span
                            className='btn-link'
                            onClick={() => clearFilters()}
                        > {messages['fleetView_clearAll']} </span>
                    </Grid>
                    <Grid item className="text-right">
                        <Button
                            type="icon"
                            icon="delete"
                            tooltip={messages['fleetView_clearFilters']}
                            placement="left"
                            onClick={() => clearFilters()}
                        />
                    </Grid>
                </Grid>
            </SidePanelHeader>

            <SidePanelBody
                style={{
                    height: "auto"
                }}
            >
                <div>
                    <Select
                        id="categoryType"
                        label={messages['behavior_category']}
                        value={filter?.categories}
                        onChange={(value) => {
                            if (value?.length) {
                                const filterMetricTypes = allMetricOptions.filter(option => {
                                    return value?.map(category => category.id).includes(option.id)
                                })
                                setMetricsTypesOptions(filterMetricTypes)
                            } else {
                                setMetricsTypesOptions(allMetricOptions)
                            }
                            dispatch(openModalBehaviorAdvanceFilter({
                                hasFilters: filter?.metrics?.length > 0 || value?.length > 0,
                                filter: {...filter, categories: value}
                            }))
                            changePreferences({...filter, categories: value})
                        }}
                        options={categoriesTypesOptions}
                        textField="label"
                        valueField="id"
                        placeholder={messages['behavior_category']}
                        isClearable
                        isOptionDisabled={(option) => {
                            return !option || option.disabled
                        }}
                        multiple
                        className={'selected-behavior-options'}
                        formatGroupLabel={formatGroupLabel}
                        titleStyles={'behavior-setup-type-title'}
                        styleIcon={{color: colors[COLOR_BLACK]}}
                        messageInfoIcon={messages["generatedReport_infoReports"]}
                    />
                    <Select
                        id="metricType"
                        label={messages['behavior_metric']}
                        value={filter?.metrics}
                        onChange={(value) => {
                            dispatch(openModalBehaviorAdvanceFilter({
                                hasFilters: filter?.categories?.length > 0 || value?.length > 0,
                                filter: {...filter, metrics: value}
                            }))
                            changePreferences({...filter, metrics: value})
                        }}
                        options={metricsTypesOptions}
                        textField="name"
                        valueField="id"
                        placeholder={messages['behavior_metric']}
                        isClearable
                        isOptionDisabled={(option) => {
                            return !option || option.disabled
                        }}
                        multiple
                        className={'selected-behavior-options'}
                        formatGroupLabel={formatGroupLabel}
                        titleStyles={'behavior-setup-type-title'}
                        styleIcon={{color: colors[COLOR_BLACK]}}
                        messageInfoIcon={messages["generatedReport_infoReports"]}
                    />
                </div>
            </SidePanelBody>
        </SidePanel>
    );
};

export default AdvanceFilterMetric
